import { Box, Button, InputField, Modal } from "fds";
import { useTranslation } from "react-i18next";

interface Props {
  /** 0: 닫힘, 1: 내부사용자 초대, 2: 외부사용자 초대 */
  openAddUserModal: number;
  addUserMail: string;
  error: { isError: boolean; errorType: string };
  onClose: () => void;
  onChangeEmail: (email: string) => void;
  onAdd: () => void;
}

const AddUserModal: React.FC<Props> = ({
  openAddUserModal,
  addUserMail,
  error,
  onClose,
  onChangeEmail,
  onAdd,
}) => {
  const { t } = useTranslation();

  if (openAddUserModal <= 0) return null;

  return (
    <Modal
      title={
        openAddUserModal === 1
          ? t("admin.manage.addInternalUser")
          : t("admin.manage.goExternalUser")
      }
      open
      onClose={onClose}
      width={500}
      footer={
        <Box>
          <Button
            label={t("common.cancel")}
            btnStyle="fill"
            type="secondary"
            onClick={onClose}
          />
          <Button
            label={t("common.add")}
            btnStyle="fill"
            onClick={onAdd}
            state={addUserMail.trim() === "" ? "disable" : "default"}
          />
        </Box>
      }
      body={
        <Box>
          <InputField
            label={t("signup.email")}
            size="md"
            width="100%"
            maxLength={64}
            isError={error.isError}
            helpMessage={error.isError ? t("common.alert.noValidEmailType") : ""}
            onChange={(e) => onChangeEmail(e.target.value)}
            placeholder={t("admin.manage.writeAddEmail")}
          />
        </Box>
      }
    />
  );
};

export default AddUserModal;
